import GPCHandlerApp from './GPCHandlerApp'

export default GPCHandlerApp
